
import React from "react";
import { EnhancedClientSelector } from "@/components/rentals/dialogs/components/EnhancedClientSelector";
import { Users } from "lucide-react";
import { Client } from "@/types/entities/client";

interface ClientSelectionSectionProps {
  selectedClientId: string;
  clients: Client[];
  onClientChange: (clientId: string) => void;
  onAddClient: () => void;
  isLoading?: boolean;
}

export const ClientSelectionSection = ({
  selectedClientId,
  clients,
  onClientChange,
  onAddClient,
  isLoading = false
}: ClientSelectionSectionProps) => {
  return (
    <div className="bg-muted/50 rounded-lg border p-4">
      <h3 className="text-lg font-medium mb-4 flex items-center">
        <Users className="mr-2 h-5 w-5 text-blue-600" />
        Информация о клиенте
      </h3>
      <EnhancedClientSelector
        selectedClientId={selectedClientId}
        clients={clients}
        onClientChange={onClientChange}
        onAddClient={onAddClient}
        isLoading={isLoading}
      />
    </div>
  );
};
